import { Image as AntdImage, ImageProps as AntdImageProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface ImageProps extends AntdImageProps {}

export const imagePrefixCls = `${CMP_PREFIX}-image`;

export const Image = ({ ...props }: ImageProps) => {
  return <AntdImage {...props} />;
};
